import { Quote } from "lucide-react";
import { useReveal } from "../../hooks/useReveal";

/**
 * Anonymised, composite feedback themes — reflective of patient experiences
 * commonly described in this practice. Replace with verified, consent-given
 * testimonials when available. (UK clinical-psychology ethics: only with
 * explicit, informed, written consent from clients.)
 */
const QUOTES = [
  {
    text: "For the first time, therapy felt like it was building something — not just settling things down.",
    attribution: "Patient · Nottingham",
  },
  {
    text: "I felt heard in a way I hadn't before. The change is quieter than I expected, and steadier.",
    attribution: "Patient · Online (UK)",
  },
  {
    text: "Dr. Ghosh was honest, warm, and pragmatic. It was clear he was paying real attention.",
    attribution: "Patient · Self-referred",
  },
];

export const Testimonials = () => {
  const ref = useReveal();
  return (
    <section
      id="voices"
      data-testid="testimonials-section"
      className="bg-[#1B2E26] text-[#FDFBF7]"
    >
      <div className="mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16 py-20 md:py-20 lg:py-24">
        <div ref={ref} className="reveal">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
            <div>
              <p className="eyebrow-rule text-[11px] uppercase tracking-[0.28em] text-[#E9E4DA]/70 mb-6">
                <span>In Their Words</span>
              </p>
              <h2 className="font-serif-display text-3xl md:text-4xl lg:text-[3rem] leading-[1.1] tracking-[-0.02em] font-medium max-w-2xl">
                Quiet change, in{" "}
                <em className="italic font-normal text-[#E9E4DA]">their own words</em>.
              </h2>
            </div>
            <p className="mt-6 text-xs uppercase tracking-[0.24em] text-[#E9E4DA]/60 max-w-xs md:text-right">
              Patient feedback
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-l border-[#E9E4DA]/15">
            {QUOTES.map((q, idx) => (
              <figure
                key={idx}
                data-testid={`testimonial-${idx + 1}`}
                className="p-8 md:p-10 border-r border-b border-[#E9E4DA]/15"
              >
                <Quote
                  size={22}
                  strokeWidth={1.4}
                  className="text-[#E9E4DA]/60"
                />
                <blockquote className="mt-6 font-serif-display text-xl md:text-2xl leading-snug text-[#FDFBF7]">
                  &ldquo;{q.text}&rdquo;
                </blockquote>
                <figcaption className="mt-6 text-[10px] uppercase tracking-[0.24em] text-[#E9E4DA]/65">
                  &mdash; {q.attribution}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
